import {
    SET_APPOINTMENT_ID,
    SET_DATE,
    SET_TIME,
    SET_SESSIONS_PER_WEEK,
    SET_SESSION_TYPE,
    SET_REPEAT,
    SET_SUBJECT_ID,
    SET_APPOINTMENT_TYPE,
    RESET_FAMILY_PRESET_VALUES,
    SET_DURATION
  } from './familyPresetValuesTypes';
  
  // Action creator for setting appointment ID
  export const setAppointmentId = (appointmentId) => ({
    type: SET_APPOINTMENT_ID,
    payload: appointmentId,
  });
  
  // Action creator for setting date
  export const setDate = (date) => ({
    type: SET_DATE,
    payload: date,
  });
  
  // Action creator for setting time
  export const setTime = (time) => ({
    type: SET_TIME,
    payload: time,
  });
  
  // Action creator for setting sessions per week
  export const setSessionsPerWeek = (sessionsPerWeek) => ({
    type: SET_SESSIONS_PER_WEEK,
    payload: sessionsPerWeek,
  });
  
  // Action creator for setting session type
  export const setSessiontype = (sessiontype) => ({
    type: SET_SESSION_TYPE,
    payload: sessiontype,
  });
  
  // Action creator for setting repeat
  export const setRepeat = (repeat) => ({
    type: SET_REPEAT,
    payload: repeat,
  });

  export const setSubjectId = (subjectId) => {
    return {
      type: SET_SUBJECT_ID,
      payload: subjectId
    };
  };


  export const setAppointmentType = (appointmentType) => {
    return {
      type: SET_APPOINTMENT_TYPE,
      payload: appointmentType
    };
  };
  
  export const setDuration = (duration) => ({
  type: SET_DURATION,
  payload: duration
});


  export const resetFamilyPresetValues = () => ({
  type: RESET_FAMILY_PRESET_VALUES,
});
  